import { useFormikContext } from 'formik'
import {FC, useEffect} from 'react'

export const LinkOauthWithTotp: FC = () => {
    const { values, setFieldValue } = useFormikContext<any>()
    const oauthType = values?.oauth_type

    useEffect(() => {
        const showTotp = oauthType === 'totp'

        setFieldValue('fieldsVisibility.totp', showTotp, false)
        setFieldValue('fieldsDisabled.totp', !showTotp, false)

        if (!showTotp) setFieldValue('totp', undefined, false)
    }, [oauthType, setFieldValue])

    return null
}
